import { ReactElement } from "react";
import { IProduction } from "../../../types";
import { TextField } from "@mui/material";

interface IProps {
  productionData: IProduction[];
}

const ProductionHeader = ({ productionData }: IProps): ReactElement => {
  const total = productionData.length;


  const keyBase = `${Date.now()}`;

  return (
    <div className="display-flex-row">
      <div className="flex-grow-0 display-flex-row flex-wrap" style={{ height: 100 }}>

        <TextField className="form-control"
          variant="standard"
          key={`${keyBase}-total-heats`}
           slotProps={{ input: { readOnly: true }}}
          label={"Total Heats"}
          defaultValue={total}/>
      </div>
    </div>
  );
};

export default ProductionHeader;
